var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sections", {
        attrs: { "is-read-only": _vm.isReadOnly },
        model: {
          value: _vm.model.sections,
          callback: function($$v) {
            _vm.$set(_vm.model, "sections", $$v)
          },
          expression: "model.sections"
        }
      }),
      _vm.model.additionalQuestions?.length
        ? _c("div", [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "px-1" },
              [
                _c("questions", {
                  attrs: {
                    "has-divider": "",
                    "is-read-only": _vm.isReadOnly,
                    value: _vm.model.additionalQuestions
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "selected-answer-questions",
                        fn: function({ questions }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "px-4" },
                              [
                                _c("questions", {
                                  attrs: {
                                    "is-read-only": _vm.isReadOnly,
                                    value: questions
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    565606720
                  )
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-title mb-4" }, [
      _c("div", { staticClass: "d-inline mr-2 bg-white" }, [
        _c("i", { staticClass: "fas fa-info-circle text-orange fa-lg" })
      ]),
      _c("span", { staticClass: "font-16 font-weight-bold" }, [
        _vm._v(" Preguntas Adicionales ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }